import { Box, Button, ButtonBase, Chip, Paper, Select, styled } from '@material-ui/core'

export const Page = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 'calc(100vh - 6.25rem)',
  maxWidth: '1440px',
  margin: '0 auto',
  padding: '2rem',
  display: 'flex',
  overflow: 'hidden',
  boxSizing: 'border-box',
  flexDirection: 'column',
  color: '#202124',
  '& .MuiTypography-body2': {
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  '& .MuiTypography-caption': {
    fontSize: '.875rem',
    lineHeight: 1.45,
  },
  '& .MuiTypography-subtitle2': {
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  [theme.breakpoints.down('sm')]: {
    height: 'auto',
    minHeight: 'calc(100vh - 6.25rem)',
    padding: '1rem',
    overflow: 'visible',
  },
}))

export const PageHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: '0 0 auto',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  gap: '1.5rem',
  marginBottom: '1.5rem',
  [theme.breakpoints.down('sm')]: {
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: '.75rem',
  },
}))

export const BackButton = styled(Button)({
  minWidth: 0,
  marginBottom: '.75rem',
  padding: 0,
  color: '#52606D',
  textTransform: 'none',
  fontSize: '.9375rem',
  fontWeight: 600,
  '&:hover': {
    color: '#315B0B',
    background: 'transparent',
  },
})

export const Counter = styled(Box)({
  display: 'inline-flex',
  alignItems: 'center',
  minHeight: '32px',
  padding: '0 .75rem',
  border: '1px solid #E1E5E9',
  borderRadius: '999px',
  color: '#52606D',
  background: '#FFFFFF',
  fontSize: '.875rem',
  fontWeight: 600,
  whiteSpace: 'nowrap',
})

export const Filters = styled(Paper)(({ theme }) => ({
  display: 'grid',
  flex: '0 0 auto',
  gridTemplateColumns: 'minmax(180px, 1.25fr) minmax(170px, .8fr) minmax(250px, 1fr) auto',
  alignItems: 'end',
  gap: '1rem',
  marginBottom: '1rem',
  padding: '1rem',
  border: '1px solid #E1E5E9',
  borderRadius: '10px',
  boxShadow: 'none',
  background: '#FFFFFF',
  '& .MuiOutlinedInput-root': {
    height: '40px',
    background: '#FFFFFF',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#C9D0D6',
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#7B8794',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#567B0D',
    borderWidth: '1px',
  },
  '& .history-date-range .MuiTextField-root': {
    width: '100% !important',
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
  [theme.breakpoints.down('xs')]: {
    gridTemplateColumns: '1fr',
  },
}))

export const FilterField = styled(Box)({
  display: 'flex',
  minWidth: 0,
  flexDirection: 'column',
  gap: '.375rem',
})

export const FilterLabel = styled('label')({
  color: '#52606D',
  fontSize: '.875rem',
  fontWeight: 600,
  lineHeight: 1.3,
})

export const FilterActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '.5rem',
  minHeight: '40px',
  [theme.breakpoints.down('md')]: {
    justifyContent: 'flex-start',
  },
}))

export const ApplyButton = styled(Button)({
  height: '40px',
  padding: '0 1rem',
  color: '#FFFFFF',
  background: '#567B0D',
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: '.9375rem',
  fontWeight: 600,
  '&:hover': {
    background: '#41620A',
    boxShadow: 'none',
  },
})

export const ClearButton = styled(Button)({
  height: '40px',
  padding: '0 .75rem',
  color: '#52606D',
  textTransform: 'none',
  fontSize: '.9375rem',
  fontWeight: 600,
})

export const TableWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  minHeight: 0,
  flex: '1 1 auto',
  '& > .MuiPaper-root': {
    display: 'flex',
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    minHeight: 0,
    margin: '0 !important',
    padding: '0 !important',
    flexDirection: 'column',
    border: '1px solid #E1E5E9',
    borderRadius: '10px',
    boxShadow: 'none',
  },
  '& .MuiTableContainer-root': {
    minHeight: 0,
    flex: '1 1 auto',
    borderRadius: 0,
    boxShadow: 'none',
  },
  '& > .MuiPaper-root > div:last-child': {
    height: '64px',
    minHeight: '64px',
    flex: '0 0 64px',
  },
  '& table': {
    minWidth: '920px',
  },
  '& thead th': {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    padding: '.75rem 1rem',
    borderBottom: '1px solid #D8DEE4',
    color: '#52606D',
    background: '#F8F9FA',
    fontSize: '.8125rem',
    fontWeight: 700,
    letterSpacing: '.02em',
    textTransform: 'uppercase',
  },
  '& thead tr:nth-child(2) th': {
    position: 'sticky',
    top: '43px',
    zIndex: 2,
    padding: 0,
  },
  '& tbody td': {
    padding: '1rem',
    borderBottom: '1px solid #EDF0F2',
    verticalAlign: 'middle',
  },
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}))

export const MobileHistory = styled(Box)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.75rem',
  },
}))

export const MobileCard = styled(Paper)({
  overflow: 'hidden',
  border: '1px solid #E1E5E9',
  borderRadius: '10px',
  boxShadow: 'none',
  background: '#FFFFFF',
})

export const MobileCardContent = styled(Box)({
  padding: '1rem',
})

export const MobileCardHeader = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '.75rem',
})

export const MobileCardOccurrence = styled(Box)({
  marginTop: '1rem',
})

export const MobileCardMeta = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '1rem',
  marginTop: '1rem',
  paddingTop: '1rem',
  borderTop: '1px solid #EDF0F2',
})

export const MobileMetaLabel = styled(Box)({
  marginBottom: '.25rem',
  color: '#667085',
  fontSize: '.75rem',
  fontWeight: 700,
  letterSpacing: '.03em',
  lineHeight: 1.3,
  textTransform: 'uppercase',
})

export const MobileExpandButton = styled(ButtonBase)({
  display: 'flex',
  width: '100%',
  minHeight: '44px',
  padding: '.625rem 1rem',
  borderTop: '1px solid #EDF0F2',
  justifyContent: 'space-between',
  color: '#52606D',
  fontSize: '.875rem',
  fontWeight: 700,
  textAlign: 'left',
})

export const MobileLoading = styled(Box)({
  display: 'flex',
  minHeight: '15rem',
  alignItems: 'center',
  justifyContent: 'center',
})

export const MobilePagination = styled(Box)({
  display: 'flex',
  minHeight: '52px',
  padding: '.5rem .75rem',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '.5rem',
  border: '1px solid #E1E5E9',
  borderRadius: '10px',
  background: '#FFFFFF',
})

export const MobilePageSize = styled(Select)({
  minWidth: '76px',
  color: '#52606D',
  fontSize: '.875rem',
  '& .MuiSelect-select': {
    paddingLeft: '.5rem',
  },
})

export const StatusChip = styled(Chip)({
  height: '24px',
  borderRadius: '999px',
  fontSize: '.8125rem',
  fontWeight: 700,
  '& .MuiChip-label': {
    padding: '0 .625rem',
  },
})

export const OverflowBadge = styled(Box)({
  display: 'inline-flex',
  alignItems: 'center',
  marginLeft: '.5rem',
  padding: '.125rem .4rem',
  borderRadius: '4px',
  color: '#B42318',
  background: '#FDECEC',
  fontSize: '.8125rem',
  fontWeight: 700,
})

export const Details = styled(Box)(({ theme }) => ({
  padding: '1rem 1.5rem 1.25rem 2rem',
  borderTop: '1px solid #EDF0F2',
  background: '#FAFBFC',
  [theme.breakpoints.down('sm')]: {
    padding: '1rem',
  },
}))

export const CauseSummary = styled(Box)({
  padding: '.875rem 1rem',
  borderLeft: '3px solid #B7791F',
  borderRadius: '0 8px 8px 0',
  color: '#4A3A16',
  background: '#FFF7E6',
})

export const Timeline = styled(Box)({
  position: 'relative',
  display: 'grid',
  gap: '1rem',
  marginTop: '.875rem',
  '&:before': {
    position: 'absolute',
    top: '.45rem',
    bottom: '.45rem',
    left: '5px',
    width: '1px',
    background: '#D8DEE4',
    content: '""',
  },
})

export const TimelineItem = styled(Box)({
  position: 'relative',
  display: 'grid',
  gridTemplateColumns: '12px 1fr',
  gap: '.75rem',
})

export const TimelineEmpty = styled(Box)({
  marginTop: '.625rem',
  color: '#667085',
  fontSize: '.875rem',
})

export const TimelineDot = styled('span')({
  position: 'relative',
  zIndex: 1,
  display: 'block',
  width: '11px',
  height: '11px',
  marginTop: '.3rem',
  border: '2px solid #FFFFFF',
  borderRadius: '50%',
  background: '#6B7C5B',
  boxShadow: '0 0 0 1px #AEB8A5',
})

export const LegacyNotice = styled(Box)({
  padding: '.75rem 1rem',
  border: '1px solid #E1E5E9',
  borderRadius: '8px',
  color: '#52606D',
  background: '#FFFFFF',
  fontSize: '.875rem',
})
